module.exports = __webpack_public_path__ + "static/img/img_guide.58746ed5.png";